// Connectivity via the browser. Same API OfflineContext already consumes.
export async function getOnlineStatus() {
  return navigator.onLine;
}
export function addNetworkListener(cb) {
  const on = () => cb(true);
  const off = () => cb(false);
  window.addEventListener('online', on);
  window.addEventListener('offline', off);
  return () => {
    window.removeEventListener('online', on);
    window.removeEventListener('offline', off);
  };
}
